import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Unsubscriber } from "../base/unsubscriber.component";

export interface PaddedImage {
  imageUrl: string;
  paddingTop: number;
  paddingRight: number;
  paddingBottom: number;
  paddingLeft: number;
}

interface PaddedImageForm {
  imageUrl: FormControl<string>;
  paddingTop: FormControl<number>;
  paddingRight: FormControl<number>;
  paddingBottom: FormControl<number>;
  paddingLeft: FormControl<number>;
}

@Component({
  selector: "app-padded-image-uploader",
  templateUrl: "./padded-image-uploader.component.html",
  styleUrls: ["./padded-image-uploader.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PaddedImageUploaderComponent,
      multi: true
    }
  ]
})
export class PaddedImageUploaderComponent extends Unsubscriber implements OnInit {
  @Input() storageFolder = "brands";
  @Input() label = "";
  @Input() tooltip = "";
  @Input() isDisabled = false;
  @Input() isClearable = false;
  @Input() hasCropper = false;
  @Input() aspectRatio = 1;

  form = new FormGroup<PaddedImageForm>({
    imageUrl: new FormControl<string>(""),
    paddingTop: new FormControl<number>(null),
    paddingRight: new FormControl<number>(null),
    paddingBottom: new FormControl<number>(null),
    paddingLeft: new FormControl<number>(null)
  });

  private onChange: (value: PaddedImage) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit(): void {
    this.sub = this.form.valueChanges.subscribe(() => {
      this.onModelChange();
    });
  }

  writeValue(obj: PaddedImage): void {
    if (obj) {
      this.form.patchValue(obj, { emitEvent: false });
    }
  }

  registerOnChange(fn: (value: PaddedImage) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    if (isDisabled) {
      this.form.disable({ emitEvent: false });
    } else {
      this.form.enable({ emitEvent: false });
    }
  }

  private onModelChange(): void {
    const rawValue = this.form.getRawValue();
    const value = {
      ...rawValue,
      paddingTop: Number(rawValue.paddingTop),
      paddingRight: Number(rawValue.paddingRight),
      paddingBottom: Number(rawValue.paddingBottom),
      paddingLeft: Number(rawValue.paddingLeft)
    };

    this.onChange(value);
    this.onTouched();
  }
}
